import { Box, Stack, Skeleton } from "@mui/material";

const WebsiteSkeleton = () => {
  return (
    <Box sx={{}}>
      {/* Tabs Skeleton */}
      <Stack direction="row" spacing={1} mb={2}>
        <Skeleton variant="rounded" width={80} height={32} />
        <Skeleton variant="rounded" width={90} height={32} />
        <Skeleton variant="rounded" width={120} height={32} />
      </Stack>

      {/* Cards Skeleton */}
      {[1, 2, 3].map((item) => (
        <Box
          key={item}
          sx={{
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            p: 2,
            mb: 2,
          }}
        >
          <Stack spacing={1.2}>
            {/* Date */}
            <Skeleton width={90} height={18} />

            {/* Spend */}
            <Skeleton width={200} height={28} />

            {/* Metrics row */}
            <Stack direction="row" justifyContent="space-between">
              <Skeleton width={180} height={20} />
              <Skeleton width={90} height={20} />
            </Stack>

            {/* Metrics row */}
            <Stack direction="row" justifyContent="space-between">
              <Skeleton width={200} height={20} />
              <Skeleton width={80} height={20} />
            </Stack>
          </Stack>
        </Box>
      ))}
    </Box>
  );
};

export default WebsiteSkeleton;
